<div class="db-one-month-free-payment-steps mb50" *ngIf="mode !== 'ssh'">
  <div class="db-one-month-free-payment-steps-icons">
    <div class="db-one-month-free-payment-steps__step active" [ngClass]="{'green': currentSubscription.trialBoosterClient}">
      <span><i class="db-icon db-icon-ds-unlocked" ></i></span>
    </div>
    <span class="db-one-month-free-payment-steps__separator active"></span>
    <div class="db-one-month-free-payment-steps__step">
      <span><i class="db-icon db-icon-ds-bell"></i></span>
    </div>
    <span class="db-one-month-free-payment-steps__separator"></span>
    <div class="db-one-month-free-payment-steps__step">
      <span><i class="db-icon db-icon-ds-checkmark"></i></span>
    </div>
    <span class="db-one-month-free-payment-steps__separator dashed"></span>
  </div>
  <div class="db-one-month-free-payment-steps-desc">
    <div>
     <p><b>Today</b></p>
      <p>Unlock {{currentSubscription?.trialBoosterClient ? '10Web Booster Pro' : '10Web Pro plans'}} for 7 days. Cancel anytime.</p>
    </div>
    <div>
      <p><b>{{notisDate | date: 'MMMM d'}}</b></p>
      <p>We will notify you 24 hours before the end of the period.</p>
    </div>
    <div>
      <p><b>{{expirationDate | date: 'MMMM d'}}</b></p>
      <p>Your subscription of 10Web will start based on the plan you selected.</p>
    </div>
  </div>
</div>

<div class="db-one-month-free-payment-steps-wrap" *ngIf="mode === 'ssh'">
  <div class="db-one-month-free-payment-steps">
    <div class="db-one-month-free-payment-steps-icons">
      <div class="db-one-month-free-payment-steps__step active">
        <span><i class="db-icon db-icon-ds-unlocked"></i></span>
      </div>
      <span class="db-one-month-free-payment-steps__separator active"></span>
      <div class="db-one-month-free-payment-steps__step">
        <span><i class="db-icon db-icon-ds-checkmark"></i></span>
      </div>
      <span class="db-one-month-free-payment-steps__separator dashed"></span>
    </div>
    <div class="db-one-month-free-payment-steps-desc">
      <div>
        <p><b>Today</b></p>
        <p>Unlock 10Web Pro plans.</p>
      </div>
      <div>
        <p><b>{{expirationDate | date: 'MMMM d, y'}}</b></p>
        <p>Your next payment date.</p>
      </div>
    </div>
  </div>
</div>
